"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _useGlobalMessage2 = _interopRequireDefault(require("../hooks/useGlobalMessage"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    container: {
      position: 'absolute',
      top: 80,
      alignItems: 'flex-start',
      width: '100%'
    },
    paper: {
      width: '100%',
      borderTop: "5px solid ".concat(palette.error.main)
    },
    closeButton: {
      position: 'absolute',
      right: spacing(2),
      top: spacing(1.5),
      color: palette.text.disabled
    },
    titleWrapper: {
      display: 'flex',
      alignItems: 'center'
    },
    titleTypography: {
      fontSize: '1.25rem',
      fontWeight: 500,
      marginLeft: spacing(2)
    },
    detailsLink: {
      display: 'inline-block'
    },
    declineButton: {
      width: '100%',
      height: '3rem',
      margin: spacing(3, 0, 2),
      color: palette.common.white,
      backgroundColor: palette.error.main,
      '&:hover': {
        backgroundColor: palette.error.light
      }
    }
  };
});

var MessageDialog = function MessageDialog() {
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      areDetailsExpanded = _useState2[0],
      setAreDetailsExpanded = _useState2[1];

  var _useGlobalMessage = (0, _useGlobalMessage2["default"])(),
      isDialogOpen = _useGlobalMessage.isDialogOpen,
      message = _useGlobalMessage.message,
      errorDetails = _useGlobalMessage.errorDetails,
      hideGlobalMessage = _useGlobalMessage.hideGlobalMessage;

  var backdropProps = (0, _react.useMemo)(function () {
    return {
      style: {
        backgroundColor: 'transparent'
      },
      'data-testid': 'GlobalMessage.Dialog.Backdrop'
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_material.Dialog, {
    open: isDialogOpen,
    BackdropProps: backdropProps,
    classes: {
      container: classes.container,
      paper: classes.paper
    },
    onClose: hideGlobalMessage,
    "data-testid": "GlobalMessage.Dialog"
  }, /*#__PURE__*/_react["default"].createElement(_material.DialogTitle, {
    className: classes.titleWrapper
  }, /*#__PURE__*/_react["default"].createElement(_ui.SlashedEyeCircle, null), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    className: classes.titleTypography
  }, "Something went wrong"), /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
    icon: "times",
    className: classes.closeButton,
    onClick: hideGlobalMessage,
    "data-testid": "GlobalMessage.Dialog.Close"
  })), /*#__PURE__*/_react["default"].createElement(_material.DialogContent, {
    "data-testid": "GlobalMessage.Dialog.Content"
  }, /*#__PURE__*/_react["default"].createElement(_material.DialogContentText, null, "Error: ", message, /*#__PURE__*/_react["default"].createElement("br", null), "Please, reach out to your program administrator."), /*#__PURE__*/_react["default"].createElement(_ui.LinkButton, {
    className: classes.detailsLink,
    onClick: function onClick() {
      return setAreDetailsExpanded(!areDetailsExpanded);
    },
    "data-testid": "GlobalMessage.Dialog.Expand"
  }, areDetailsExpanded ? 'Hide' : 'See', " details"), areDetailsExpanded && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    mt: 1
  }, /*#__PURE__*/_react["default"].createElement(_ui.AlyceCodeBlock, {
    text: errorDetails
  })), /*#__PURE__*/_react["default"].createElement(_ui.BaseButton, {
    onClick: hideGlobalMessage,
    className: classes.declineButton,
    "data-testid": "GlobalMessage.Dialog.Ok"
  }, "OK")));
};

var _default = /*#__PURE__*/(0, _react.memo)(MessageDialog);

exports["default"] = _default;